import { Configuration } from '@azure/msal-browser'
import { GraphConfigType, ScopesType } from './types'

const b2cPolicies = {
  names: {
    signUpSignIn: 'B2C_1A_LOGIN',
  },
  authorities: {
    signUpSignIn: {
      authority: import.meta.env.VITE_MSAL_AUTH_POLICY,
    },
  },
  authorityDomain: import.meta.env.VITE_MSAL_AUTH_DOMAIN
}

// const apiConfig = {
//   b2cScopes: ['https://sucdenclientportalpoc.onmicrosoft.com/CPProperties/Read.User.All'],
//   webApi: 'http://localhost:8080/onboarding'
// }

export const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_MSAL_CLIENT_ID,
    authority: b2cPolicies.authorities.signUpSignIn.authority, // Choose sign-up/sign-in user-flow as your default.
    knownAuthorities: [b2cPolicies.authorityDomain], // You must identify your tenant's domain as a known authority.
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },/*
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case msal.LogLevel.Error:
            console.error(message);
            return;
          case msal.LogLevel.Info:
            console.info(message);
            return;
          case msal.LogLevel.Verbose:
            console.debug(message);
            return;
          case msal.LogLevel.Warning:
            console.warn(message);
            return;
        }
      }
    }
  }*/
}

export const SCOPES: ScopesType = {
  main: import.meta.env.VITE_MSAL_CP_API_SCOPE,
  onboarding: import.meta.env.VITE_MSAL_ONBOARDING_SCOPE
}

export const graphConfig: GraphConfigType = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',
}
